import Type from "@/model/types/Type";

const type = {

    GO_TO_STEP: 1,
    FINISH_WITH_ERROR: 2,
    CHANGE_STATUS_OPERATIONAL: 3,
    BLOCK: 4,
    INFO: 5,
    ALTERNATIVES: 6,
}

const list = [
    {
        value: type.GO_TO_STEP,
        text: "Ir para etapa de correção",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar com erro",
    },
    {
        value: type.CHANGE_STATUS_OPERATIONAL,
        text: "Alterar status operacional",
    },
    {
        value: type.BLOCK,
        text: "Bloquear e não permitir avançar",
    },
    {
        value: type.INFO,
        text: "Informar apenas, sem bloquear",
    },
    {
        value: type.ALTERNATIVES,
        text: "Exibir alternativas",
    },
]

const contains = function (type) {
    return Type.contains(list, type)
}

const getText = function (type) {
    return Type.getText(list, type)
}

export default {
    type,
    list,
    contains,
    getText,
}


